
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ModalWindow from "modal-window";

@Component({
  components: {
    "modal-window": (ModalWindow as any).default || ModalWindow,
  },
})
export default class CustomModalComponent extends Vue {
  @Prop({ default: "Да" }) yesText: string;
  @Prop({ default: "Нет" }) noText: string;
  @Prop() title: string;
  @Prop() visible: boolean;
  @Prop({ default: false }) autoClose: boolean;
  @Prop() noButton: boolean;
  @Prop({ default: true }) isButtonContent: boolean;
  @Prop() width: string;
  @Prop({ default: false }) autoHeight: boolean;
  @Prop({ default: false }) noScroll: boolean;
  close(pars: any) {
    this.$emit("close", pars);
  }
  onCancel() {
    this.$emit("cancel");
    this.$emit("close");
  }
  onOk() {
    this.$emit("ok");
    if (this.autoClose) this.$emit("close");
  }
}
